import { useCallback, useState } from 'react';
// types
import { LoSam } from 'src/types/losam';
import { CaySam } from 'src/types/caysam';
// hooks
import { useLoSam } from './use-losam';

type GridSize = { x: number; y: number };

type SelectedCellInfo = {
  position: string;
  x: number;
  y: number;
  isEdit: boolean;
  caySam?: CaySam;
} | null;

export type LoSamPosition = {
  x: number;
  y: number;
  selected: boolean;
  occupied: boolean;
  lotId: number;
  caySam?: CaySam;
};

type UseTraCuuParams = {
  selectedLot: LoSam | null;
  gridSize: GridSize;
  gridPositions: LoSamPosition[][];
  loadCaySams: (loSamId: number) => Promise<void>;
};

export default function useTraCuuLoSam({ selectedLot, gridSize, gridPositions, loadCaySams }: UseTraCuuParams) {
  const { parseViTriTrongLo, loaiTuoiOptions } = useLoSam();

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedCellInfo, setSelectedCellInfo] = useState<SelectedCellInfo>(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    maCaySam: '',
    tuoiCay_ID: '',
    blockChain: '',
    trangThai: '1', 
    hinhAnhTongQuan: '',
    hinhAnhChiTiet: '',
  });
 
  const handlePositionClick = useCallback((x: number, y: number) => {
    if (!selectedLot) return;
    const middleColumn = Math.floor(gridSize.x / 2);
    if (x === middleColumn) return; // walkway

    const position = gridPositions[y]?.[x];
    let adjustedX = x;
    if (x > middleColumn) adjustedX = x - 1;
    const positionLabel = `${String.fromCharCode(65 + adjustedX)}${y + 1}`;

    if (position?.caySam) {
      setSelectedCellInfo({ position: positionLabel, caySam: position.caySam, x: adjustedX, y, isEdit: true });
      
      // Lấy tình trạng từ nhật ký mới nhất
      const latestNhatKy = position.caySam.caySamNhatKys && position.caySam.caySamNhatKys.length > 0
        ? position.caySam.caySamNhatKys[position.caySam.caySamNhatKys.length - 1]
        : null;
      const latestTrangThai = latestNhatKy?.tinhTrang?.toString() || '1'; // Default to 1 if no status
      
      setFormData({
        maCaySam: position.caySam.maCaySam || '',
        tuoiCay_ID: position.caySam.tuoiCay_ID?.toString() || '',
        blockChain: position.caySam.blockChain || '',
        trangThai: latestTrangThai,
        hinhAnhTongQuan: latestNhatKy?.hinhAnhTongQuan || '',
        hinhAnhChiTiet: latestNhatKy?.hinhAnhChiTiet || '',
      });
    } else {
      setSelectedCellInfo({ position: positionLabel, x: adjustedX, y, isEdit: false });
      setFormData({
        maCaySam: `${selectedLot.maLo}_${positionLabel}`,
        tuoiCay_ID: '',
        blockChain: '',
        trangThai: '1',
        hinhAnhTongQuan: '',
        hinhAnhChiTiet: '',
      });
    }
    setOpenDrawer(true);
  }, [gridPositions, gridSize.x, selectedLot]);

  const handleCloseDrawer = useCallback(() => {
    setOpenDrawer(false);
    setSelectedCellInfo(null);
    setFormData({ maCaySam: '', tuoiCay_ID: '', blockChain: '', trangThai: '1', hinhAnhTongQuan: '', hinhAnhChiTiet: '' });
  }, []);

  const handleDeleteCaySam = useCallback(async () => {
    if (!selectedCellInfo?.caySam || !selectedLot) return;
    try {
      setLoading(true);
      await loadCaySams(selectedLot.loSam_ID!);
      handleCloseDrawer();
    } finally {
      setLoading(false);
    }
  }, [handleCloseDrawer, loadCaySams, selectedCellInfo, selectedLot]);

  return {
    // state
    openDrawer,
    selectedCellInfo,
    loading,
    formData,
    loaiTuoiOptions,
    // setters
    setFormData,
    setOpenDrawer,
    setSelectedCellInfo,
    // actions
    handlePositionClick,
    handleCloseDrawer,
    handleDeleteCaySam,
    // helpers
    parseViTriTrongLo,
  };
}


